document.addEventListener("DOMContentLoaded", function () {
    // Read more FAQs
    const readMoreBtn = document.querySelector('.read-more-faq');
    const extraFaqs = document.querySelectorAll('.extra-faq');

    if (readMoreBtn && extraFaqs) {
        readMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            readMoreBtn.style.display = 'none';
            // Fade in each FAQ one by one
            extraFaqs.forEach((faq, index) => {
             faq.classList.add('show'); // Add class to trigger smooth animation
           });
            extraFaqs.forEach((faq, index) => {
                setTimeout(() => {
                    faq.classList.add('fade-in'); // Add class to trigger smooth animation
                }, index * 200); // Delay of 300ms per item for sequential fade-in
            });

           
        });
    }
});
